import {inject, injectable} from 'inversify';

import type {EditionExpandFieldsCommon} from '../../../../api/program/edition/types';
import type {Expand} from '../../../../api/types';

import {editionExpandCommon} from '../../../../api/program';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class EditionExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = editionExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace EditionExpandJrpc {
  export type ExpandedFields = EditionExpandFieldsCommon;
}
